import { plan6, plan_mapping } from './../../core/services/constants';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from "@angular/router";
import { MiddlwareService } from 'src/app/core/services/middleware.service';

@Component({
  selector: 'app-plan-modal',
  templateUrl: './plan-modal.component.html',
  styleUrls: ['./plan-modal.component.scss']
})
export class PlanCheckComponent {
  @Output() close = new EventEmitter<any>(null);
  @Input() requiredPlan;
  modalRef?: BsModalRef;
  maxPlanLevel= 3;

  planLevel: number;

  constructor(
    private router: Router,
    private mdw: MiddlwareService,
  ) {}

  ngOnInit() {
    const requiredPlanId = plan_mapping[this.requiredPlan].id;
    this.planLevel = plan_mapping[this.requiredPlan].level;
    console.log("this.planLevel", this.planLevel)
  }

  get showOrHigher(): boolean {
    const plan: any = plan_mapping[this.requiredPlan];
    return !!plan && plan.level < this.maxPlanLevel;
  }

  // Title that you will use in the template
  get requiredPlanTitle(): string {
    const plan = plan_mapping[this.requiredPlan];
    return plan?.title || 'Professional'; // fallback if needed
  }

  viewPlans() {
    this.closeNotify();
    this.router.navigate(["/billings/plans"]);
  }

  unlockProfessionalApp() {
    this.closeNotify();
    const requiredPlanId = plan_mapping[this.requiredPlan].id;
    this.mdw._selectedPlan.next(requiredPlanId);
    this.router.navigate(["/billings/form"]);
  }

  closeNotify() {
    this.close.emit(true);
  }
}
